import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import { datadogLogs } from "@datadog/browser-logs";

// Import stylesheets
import "../stylesheets/application.scss";

datadogLogs.init({
  clientToken: "pub883e282c4b8ff9456d688fdbe72fe60f",
  site: "datadoghq.eu",
  forwardErrorsToLogs: true,
  sampleRate: 100,
  service: "cortana-js",
  env: window._ENV,
  beforeSend: (log) => {
    if (log.message.includes("XHR error GET")) {
      return false;
    }
  },
});

Rails.start();
Turbolinks.start();

Turbolinks.Visit.prototype.performScroll = function () {
  if (!this.scrolled) {
    if (this.action == "replace") {
      // do nothing
    } else if (this.action == "restore") {
      this.scrollToRestoredPosition() || this.scrollToTop();
    } else {
      this.scrollToAnchor() || this.scrollToTop();
    }
    this.scrolled = true;
  }
};

import "../javascript/legacy/";
import "../javascript/controllers";
